<template lang="">
    <div>
        <select v-if="validQuantities" v-model="myValue" class="form-control" @change="update">
            <option v-for="(value, index) in validQuantities" :key="index" :value="value">{{ value
                }}</option>
        </select>
        <template v-else>
            庫存數量不足
        </template>
    </div>
</template>
<script>
    import tools from '../../../library/tools';

    export default {
        props: {
            storage: {
                default: false
            },
            value: {
                default: undefined
            }
        },
        data() {
            return {
                myValue: undefined
            };
        },
        mounted() {
            this.myValue = this.value;
        },
        computed: {
            validQuantities() {
                let { storage } = this;
                let stock = storage.stock,
                    minimum = storage.minimum,
                    maximum = storage.maximum;
                maximum = stock < maximum ? stock : maximum;
                return !Object.keys(storage).length ||
                    stock < minimum || stock === null ? false
                    : tools.range(minimum, maximum);
            }
        },
        methods: {
            update(e) {
                this.$emit('input', this.myValue);
            }
        },
        watch: {
            storage(newValue, oldValue) {
                // tools.printObservable(newValue, oldValue);
                if (this.validQuantities &&
                    (!this.value || this.validQuantities.indexOf(this.value) === -1)) {
                    this.myValue = this.validQuantities[0];
                    this.update();
                }
            },
            value(newValue, oldValue) {
                this.myValue = newValue;
            }
        }
    }
</script>
<style lang="">

</style>